import styled, { css } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  $textColor?: string;
}

export const BrandSquareTabItem = styled.div<IProps>`
  width: 72px !important;

  .btn {
    width: 100%;
    flex-direction: column;
  }

  .img {
    height: 72px;
    border-radius: 2px;

    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.03);
    }
  }

  .text-wrap {
    width: 100%;
    margin-top: 8px;
  }

  &.active {
    .img:before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: transparent;
      border: 2px solid #000;
      z-index: 1;
    }

    .text {
      font-weight: 600;
      color: #000;
    }
  }

  &.color-type-black {
    .text {
      color: #777;
    }

    &.active {
      .img:before {
        border-color: #777;
      }

      .text {
        color: #fff;
      }
    }
  }

  &.color-type-gray {
    .text {
      color: #777;
    }

    &.active {
      .img:before {
        border-color: #777;
      }

      .text {
        color: #fff;
      }
    }
  }

  ${({ $textColor }) =>
    $textColor &&
    css`
      &.active {
        .img:before {
          border-color: ${$textColor};
        }

        .text {
          color: ${$textColor};
        }
      }
    `}

  @media ${({ theme }) => theme.media.smMax} {
    width: ${mixin.pxToVw('72')} !important;

    .img {
      height: ${mixin.pxToVw('72')};
    }

    .text-wrap {
      margin-top: ${mixin.pxToVw('8')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    width: 130px !important;

    &.active .img:after {
      background: rgba(0, 0, 0, 0.03);
    }

    .img {
      height: 82px;

      &:after {
        background: rgba(255, 255, 255, 0.5);
      }
    }

    .text-wrap {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      padding: 6px;
      margin: 0;
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.5) 100%
      );
      border-radius: 0 0 2px 2px;
    }

    .text {
      font-size: 14px;
      text-align: left;
      color: #fff !important;
      ${mixin.ellipsis(2)}
    }
  }
`;
